// extracted by mini-css-extract-plugin
module.exports = {"vGray14":"#7d85a4","group":"ReportsFreedomIncomeListGroup_group__tuZME","date":"ReportsFreedomIncomeListGroup_date__3ao7B"};